/**
 * @flow
 * @relayHash cf5b7617ba0a8161edb2f75db9c5f49a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvoiceSupplierUpdateInput = {|
  id: string,
  num: string,
  title: string,
  description?: ?string,
  address: string,
  date: any,
  tax?: ?string,
  postStamp?: ?string,
  discountType?: ?string,
  discountValue?: ?string,
  total: string,
  totalTTC: string,
  currencyId: string,
  supplierId: string,
  invoiceSupplierItem: $ReadOnlyArray<InvoiceSupplierItemCreateInput>,
|};
export type InvoiceSupplierItemCreateInput = {|
  designation: string,
  description?: ?string,
  quantity: string,
  unityId: string,
  discount?: ?string,
  unitPrice: string,
  total: string,
|};
export type UpdateInvoiceSupplierMutationVariables = {|
  data: InvoiceSupplierUpdateInput
|};
export type UpdateInvoiceSupplierMutationResponse = {|
  +updateInvoiceSupplier: {|
    +id: string
  |}
|};
export type UpdateInvoiceSupplierMutation = {|
  variables: UpdateInvoiceSupplierMutationVariables,
  response: UpdateInvoiceSupplierMutationResponse,
|};
*/


/*
mutation UpdateInvoiceSupplierMutation(
  $data: InvoiceSupplierUpdateInput!
) {
  updateInvoiceSupplier(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "InvoiceSupplierUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoiceSupplier",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "InvoiceSupplierModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateInvoiceSupplierMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateInvoiceSupplierMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateInvoiceSupplierMutation",
    "id": null,
    "text": "mutation UpdateInvoiceSupplierMutation(\n  $data: InvoiceSupplierUpdateInput!\n) {\n  updateInvoiceSupplier(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ceb9a2d0a5f95157870b8791ff85bd7e';
module.exports = node;
